import React from 'react'

interface Props {
  currentSelectedCar: string,
  currentCompleteCar?: string
}

interface State {}

class CurrentCarName extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {

    }
  }

  render(): React.ReactNode {
    const modelKey = this.props.currentSelectedCar;
    const versionKey = (this.props.currentCompleteCar || '').replace(modelKey, '').trim();
    return(
      <div className='current-car-name-mobile' style={{pointerEvents: "none"}}>
        {require('../../helpers/strapi.helper').getCarDisplayName(modelKey, versionKey)}
      </div>
    )
  }
}

export default CurrentCarName;